module.exports = __webpack_public_path__ + "img/2.2ac654d8.png";